import Slider from "../Components/Slider/Slider";
import Content from "../Components/Content/Content";
import Partner from "../Components/Partner/Partner";
import Pricing from "../Components/Pricing/Pricing";
import Content2 from "../Components/Content/Content2";
import Faq from "../Components/Faq/Faq";
import Layout from "./Layout";

export default function Main() {
  return (
    <Layout>
      <Slider />
      <Partner />
      <Content />
      <Pricing />
      <Content2 />
      <Faq />
    </Layout>
  );
}
